<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (
    [MESSAGE_VARIANTS.ACTIVITY, MESSAGE_VARIANTS.ACTIVITY_POST].includes(
      variant.value
    )
  ) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});
</script>

<template>
  <span
    v-dompurify-html="formattedContent"
    class="[&_ol]:pl-5 [&_ol]:list-decimal [&_ul]:pl-5 [&_ul]:list-disc"
  />
</template>
